var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layoutWide',[_c('sub-navbar',{attrs:{"page":"Transaction"}}),_c('div',[_vm._v("Payments To Suppliers")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }